<p class="mb-4">
    Are you sure you want to pause the visuals of this channel? If yes, please make sure to upload
    the new visuals. Your new visuals if approved will be visible at least after 2 working days
</p>
<div class="d-flex align-items-center justify-content-center">
    <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>No</button>

    <button (click)="pauseCampaignVisual()" [disabled]="pausing" class="btn btn-md btn-gray-500">
        yes
    </button>
</div>
